import React from 'react';
import {StyleSheet} from 'react-native';

import Text from '../Text';

type Props = {
  children: string;
};
const Label = ({children}: Props) => <Text style={styles.main}>{children}</Text>;

const styles = StyleSheet.create({
  main: {
    color: 'grey',
    fontSize: 12,
    marginBottom: 4,
  },
});

export default Label;
